import React from 'react'
import { TransitionGroup, CSSTransition } from 'react-transition-group'

export default ({children, location, location: {state}}) => {
  let classNames = 'fade'

  if (typeof state !== 'undefined' && state.to) {
    switch (state.to) {
      case 'home':
        classNames = 'home'
        break
      case 'trip':
        classNames = 'trip'
        break
      case 'page':
        classNames = 'page'
        break
      default:
        classNames = 'fade'
        break
    }
  }

  return (
    <TransitionGroup>
      <CSSTransition
        key={location.key}
        classNames={classNames}
        timeout={3000}
      >
        {children}
      </CSSTransition>
    </TransitionGroup>
  )
}


// WEBPACK FOOTER //
// ./src/components/Transition/Transition.js